import React from "react";
import TimeCountDown from "../countdown";

interface WeddingDateProps {
    wClass?: string;
}

const WeddingDate: React.FC<WeddingDateProps> = ({ wClass }) => {
    return (
        <section className={`wpo-wedding-date ${wClass || ""}`}>
            <h2 className="d-none">hidden</h2>
            <div className="container">
                <div className="wedding-date-wrap">
                    <div className="clock-grids">
                        <div id="clock">
                            <TimeCountDown />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WeddingDate;
